import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { SectionDivider } from './ui/SectionDivider';
export function Hero() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative w-full min-h-[90vh] flex flex-col bg-cream-50 overflow-hidden" data-id="element-56">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-30 pointer-events-none" data-id="element-57">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-rose-muted blur-[100px] opacity-20" data-id="element-58" />
        <div className="absolute bottom-[10%] left-[-10%] w-[400px] h-[400px] rounded-full bg-terracotta-light blur-[80px] opacity-10" data-id="element-59" />
      </div>

      <div className="flex-grow flex items-center justify-center px-6 py-20 md:py-32 relative z-10" data-id="element-60">
        <div className="max-w-4xl mx-auto text-center" data-id="element-61">
          <FadeIn delay={0.1} data-id="element-62">
            <span className="inline-block py-1 px-3 rounded-full bg-terracotta/10 text-terracotta text-sm font-medium tracking-wide mb-6" data-id="element-63">
              PARA MUJERES LATINAS EN USA
            </span>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-64">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-medium text-brown-900 leading-[1.1] mb-8" data-id="element-65">
              Deja de adivinar <br className="hidden md:block" data-id="element-66" />
              <span className="italic text-terracotta" data-id="element-67">tu pelo.</span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.4} className="max-w-2xl mx-auto space-y-6 text-lg md:text-xl text-brown-800/80 leading-relaxed font-sans" data-id="element-68">
            <p data-id="element-69">Hay dos tipos de mujeres:</p>
            <p data-id="element-70">
              Las que "tienen buen pelo"… y las que sienten que su pelo las
              traiciona.
            </p>
            <p data-id="element-71">
              Pero la verdad es más incómoda: no es que ellas tengan suerte.{' '}
              <br className="hidden md:block" data-id="element-72" />
              Es que{' '}
              <strong className="text-brown-900 font-semibold" data-id="element-73">
                tú estás jugando un juego sin reglas.
              </strong>
            </p>
            <p className="text-base md:text-lg mt-4" data-id="element-74">
              Porque cuando no sabes exactamente qué hacer para tu{' '}
              <strong className="text-terracotta" data-id="element-75">tipo (1A–4C)</strong>, haces
              lo que hace cualquiera cuando está cansada: pruebas, compras,
              repites.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} className="mt-12" data-id="element-76">
            <button onClick={scrollToPricing} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white transition-all duration-300 bg-terracotta rounded-full hover:bg-terracotta-hover hover:scale-105 shadow-lg shadow-terracotta/20" data-id="element-77">
              Quiero mi guía
              <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" data-id="element-78" />
            </button>
            <p className="mt-4 text-sm text-brown-800/60" data-id="element-79">
              Descarga inmediata • Guía PDF completa
            </p>
          </FadeIn>
        </div>
      </div>

      <SectionDivider variant="wave" position="bottom" color="#F3EDE4" data-id="element-80" />
    </section>;
}